var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocushareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 71,
    viewBox: "0 0 354 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.751099 0.672501H20.1587L0.751099 23.455V0.672501Z",
    fill: "url(#paint0_linear_201_219)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6396 23.455H20.1262C19.2809 21.57 18.3707 18.9375 17.9481 15.72C17.0704 8.7325 19.0534 3.1425 20.1262 0.672501H32.1543C45.6454 0.672501 57.1534 10.1625 61.6071 23.455H61.6396Z",
    fill: "url(#paint1_linear_201_219)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4601 39.185C63.5576 38.015 63.6226 36.845 63.6226 35.675C63.6226 33.01 63.33 30.41 62.8424 27.9075H0.751099V39.2175H63.4926L63.4601 39.185Z",
    fill: "url(#paint2_linear_201_219)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.751099 70.6775H32.1868C41.3217 70.6775 49.5464 66.3225 55.3004 59.3675H0.751099V70.6775Z",
    fill: "url(#paint3_linear_201_219)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4212 54.9475C60.4368 51.535 61.9322 47.7325 62.8099 43.6375H0.751099V54.9475H58.4537H58.4212Z",
    fill: "url(#paint4_linear_201_219)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5362 31.775H4.65213V35.35H10.5362V31.775Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5362 47.505H4.65213V51.08H10.5362V47.505Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5362 63.2675H4.65213V66.8425H10.5362V63.2675Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1587 0.672501L0.751099 23.455V0.672501H20.1587Z",
    fill: "#0413DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5038 49.6825V15.98H88.3616C91.3524 15.98 94.0181 16.6625 96.3912 17.995C98.7643 19.36 100.617 21.245 101.95 23.715C103.283 26.185 103.966 28.9475 103.966 32.0025V33.5625C103.966 36.65 103.316 39.4125 102.015 41.85C100.715 44.2875 98.8619 46.205 96.4887 47.6025C94.1156 48.9675 91.4824 49.6825 88.5567 49.6825H77.4713H77.5038ZM85.6309 22.2525V43.4425H88.4591C90.7998 43.4425 92.5877 42.5975 93.823 40.94C95.0584 39.2825 95.7085 36.8125 95.7085 33.53V32.0675C95.7085 28.8175 95.0909 26.3475 93.823 24.69C92.5877 23.0325 90.7347 22.22 88.3616 22.22H85.6309V22.2525Z",
    fill: "#1B1464"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.734 33.4975C136.734 36.78 136.117 39.705 134.914 42.24C133.678 44.775 131.956 46.725 129.712 48.09C127.469 49.455 124.901 50.1375 122.04 50.1375C119.18 50.1375 116.612 49.4875 114.401 48.155C112.19 46.8225 110.435 44.9375 109.2 42.5C107.964 40.03 107.314 37.235 107.249 34.05V32.165C107.249 28.85 107.867 25.9575 109.07 23.4225C110.272 20.8875 112.028 18.9375 114.271 17.5725C116.546 16.2075 119.115 15.525 122.008 15.525C124.901 15.525 127.404 16.2075 129.647 17.5725C131.891 18.9375 133.613 20.855 134.881 23.3575C136.117 25.86 136.767 28.7525 136.767 31.97V33.53L136.734 33.4975ZM128.477 32.1C128.477 28.7525 127.924 26.2175 126.787 24.4625C125.681 22.74 124.056 21.8625 121.975 21.8625C117.912 21.8625 115.734 24.9175 115.506 31.0275V33.4975C115.506 36.8125 116.026 39.3475 117.132 41.1025C118.237 42.89 119.862 43.7675 122.008 43.7675C124.153 43.7675 125.649 42.89 126.754 41.1675C127.859 39.4125 128.445 36.91 128.445 33.6275V32.0675L128.477 32.1Z",
    fill: "#1B1464"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.203 38.2425C168.105 40.5825 167.455 42.6625 166.317 44.45C165.147 46.2375 163.521 47.635 161.441 48.6425C159.36 49.6175 156.955 50.1375 154.289 50.1375C149.868 50.1375 146.357 48.7075 143.821 45.815C141.286 42.9225 139.985 38.86 139.985 33.595V31.9375C139.985 28.6225 140.57 25.73 141.708 23.26C142.846 20.79 144.504 18.8725 146.682 17.5075C148.827 16.1425 151.331 15.4925 154.191 15.4925C158.287 15.4925 161.571 16.565 164.041 18.71C166.512 20.855 167.942 23.845 168.268 27.615H160.173C160.108 25.5675 159.588 24.0725 158.613 23.195C157.637 22.285 156.142 21.8625 154.159 21.8625C152.176 21.8625 150.648 22.61 149.705 24.1375C148.762 25.665 148.275 28.07 148.21 31.385V33.7575C148.21 37.365 148.665 39.9325 149.575 41.46C150.485 43.02 152.046 43.7675 154.256 43.7675C156.467 43.7675 157.54 43.3125 158.548 42.435C159.523 41.5575 160.075 40.16 160.108 38.2425H168.203Z",
    fill: "#1B1464"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.468 15.9475V38.015C198.468 40.5175 197.948 42.695 196.875 44.515C195.802 46.335 194.274 47.7325 192.291 48.7075C190.308 49.65 187.935 50.1375 185.237 50.1375C181.141 50.1375 177.89 49.065 175.549 46.9525C173.176 44.8075 171.974 41.915 171.941 38.21V15.98H180.101V38.3725C180.198 42.0775 181.921 43.8975 185.237 43.8975C188.553 43.8975 188.195 43.4425 189.073 42.5C189.951 41.59 190.373 40.0625 190.373 37.9825V15.98H198.5L198.468 15.9475Z",
    fill: "#1B1464"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220.931 40.7125C220.931 39.51 220.509 38.6 219.664 37.95C218.818 37.3 217.355 36.585 215.242 35.9025C213.129 35.1875 211.406 34.505 210.041 33.855C205.685 31.71 203.474 28.7525 203.474 25.015C203.474 21.2775 204.027 21.505 205.1 20.075C206.173 18.645 207.733 17.54 209.716 16.7275C211.699 15.9475 213.942 15.525 216.445 15.525C218.948 15.525 221.029 15.9475 222.979 16.825C224.897 17.7025 226.393 18.905 227.466 20.53C228.538 22.1225 229.059 23.9425 229.059 25.99H220.964C220.964 24.625 220.541 23.5525 219.696 22.805C218.851 22.0575 217.713 21.6675 216.283 21.6675C214.852 21.6675 213.682 21.9925 212.837 22.6425C211.992 23.2925 211.569 24.105 211.569 25.08C211.569 26.055 212.024 26.7375 212.967 27.42C213.877 28.135 215.535 28.85 217.843 29.5975C220.184 30.345 222.102 31.1575 223.597 32.0025C227.238 34.115 229.059 37.0075 229.059 40.68C229.059 44.3525 227.953 45.945 225.71 47.635C223.5 49.325 220.444 50.17 216.575 50.17C212.707 50.17 211.374 49.6825 209.163 48.7075C206.953 47.7325 205.295 46.4 204.157 44.6775C203.052 42.9875 202.467 41.005 202.467 38.795H210.626C210.626 40.615 211.081 41.9475 212.024 42.7925C212.967 43.6375 214.462 44.0925 216.575 44.0925C218.688 44.0925 218.981 43.8 219.761 43.215C220.541 42.63 220.931 41.8175 220.931 40.7775V40.7125Z",
    fill: "#1B1464"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M261.404 49.6825H253.31V35.61H241.347V49.6825H233.22V15.98H241.347V29.37H253.31V15.98H261.404V49.6825Z",
    fill: "#1B1464"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.144 43.3775H274.993L273.043 49.6825H264.363L276.716 15.98H284.356L296.806 49.6825H288.062L286.078 43.3775H286.144ZM276.944 37.105H284.193L280.552 25.405L276.944 37.105Z",
    fill: "#1B1464"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M311.825 37.755H307.437V49.6825H299.309V15.98H312.573C316.571 15.98 319.692 16.8575 321.935 18.645C324.178 20.4325 325.316 22.935 325.316 26.1525C325.316 29.37 324.829 30.4425 323.886 31.97C322.943 33.4975 321.448 34.765 319.432 35.7075L326.487 49.325V49.6825H317.774L311.825 37.755ZM307.437 31.515H312.573C314.101 31.515 315.271 31.125 316.051 30.3125C316.832 29.5 317.222 28.3625 317.222 26.9C317.222 25.4375 316.832 24.3 316.051 23.4875C315.271 22.675 314.101 22.2525 312.573 22.2525H307.437V31.5475V31.515Z",
    fill: "#1B1464"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M351.128 35.35H338.352V43.41H353.436V49.65H330.225V15.9475H353.501V22.22H338.352V29.3375H351.128V35.35Z",
    fill: "#1B1464"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_219",
    x1: 23.9297,
    y1: 12.0475,
    x2: -17.1611,
    y2: 12.0475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25EBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_219",
    x1: 70.1893,
    y1: -29,
    x2: -22.6796,
    y2: 12.0655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25EBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_219",
    x1: 73.5052,
    y1: 33.5625,
    x2: -55.3911,
    y2: 33.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25EBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_201_219",
    x1: 73.5052,
    y1: 65.055,
    x2: -55.3911,
    y2: 65.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25EBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_201_219",
    x1: 73.5052,
    y1: 49.2925,
    x2: -55.3911,
    y2: 49.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25EBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210FF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocushareLogo);
export default __webpack_public_path__ + "static/media/docushare-logo.7b1bb9102b16aeee9b0dc932054057f2.svg";
export { ForwardRef as ReactComponent };